import React, {Fragment, useEffect, useState} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectSection2 from '../../components/ProjectSection2/ProjectSection2';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/ctaSection/ctaSection';
import Navbar2 from '../../components/Navbar2/Navbar2';
import img from '../../images/raw-coffee.jpg'
import { getProjects } from '../../api/project';
import StarLoader from '../../components/loader/StarLoader';


const ProjectPageS2 =() => {
    const [projects, setProjects] = useState([]);
      const [loading, setLoading] = useState(true);
    
      useEffect(() => {
        async function fetchData() {
          try {
            const data = await getProjects();
            setProjects(data);
          } catch (error) {
            console.log(error);
          } finally {
            setLoading(false);
          }
        }
        fetchData();
      }, []);
    
      if (loading) {
        return <StarLoader />;
      }

    return(
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} />
            <PageTitle pageTitle={'Projects'} pagesub={'Project'} img={img}/> 
            <ProjectSection2 projects={projects} pClass={'border-bt'}/>
            <CtaSection />
            <Footer />
            <Scrollbar/>
        </Fragment>
    )
};
export default ProjectPageS2;
